module.exports = __webpack_public_path__ + "img/cross.7c4e6e87.svg";